module.exports = __webpack_public_path__ + "img/572.17de8579.png";